var styles = {
  "SearchField": "Polaris-Filters-SearchField",
  "Label": "Polaris-Filters-SearchField__Label",
  "Input": "Polaris-Filters-SearchField__Input",
  "borderless": "Polaris-Filters-SearchField--borderless",
  "focused": "Polaris-Filters-SearchField--focused",
  "Suffix": "Polaris-Filters-SearchField__Suffix",
  "ClearButton": "Polaris-Filters-SearchField__ClearButton",
  "ClearButton-focused": "Polaris-Filters-SearchField__ClearButton--focused",
  "Spinner": "Polaris-Filters-SearchField__Spinner"
};

export { styles as default };
